import { render, staticRenderFns } from "./NewInvitation.vue?vue&type=template&id=42b4c73a&"
import script from "./NewInvitation.vue?vue&type=script&lang=js&"
export * from "./NewInvitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports